import callCmAPI from 'services/helpers/call-cm-api'

export const deleteCustomer = (customerId) =>
  callCmAPI(`/customer/${customerId}`, {
    method: 'delete',
  })
    .then((res) => res.data)
    .catch((err) => err)
